import { lazy } from "react";

export { PRODUCTS_PATH } from "./products-path";
export const ProductsPage = lazy(() => import("./products-page"));
